import React from "react";
import Marquee from "react-fast-marquee";
import { useWebData } from "../../Context/webDataContext";
import img1 from '../../aseets/featured/img1.svg';
import img2 from '../../aseets/featured/img2.svg';
import img3 from '../../aseets/featured/img3.svg';
import img4 from '../../aseets/featured/img4.png';

function FeaturedIn() {
  const { websiteData } = useWebData();
  const featuredSection = websiteData.featured_in || {};

  // Get the images array; default to empty if not set
  const imagesArray = featuredSection.images?.images || [];

  // Fallback images array
  const fallbackImages = [img1, img2, img3, img4];

  return (
    <section className="lg:my-16 my-8 bg-white lg:py-10">
      <h2 className="manrope text-center text-2xl lg:text-4xl font-bold text-[#08875D] lg:mb-12 mb-6">
        Featured In
      </h2>

      <div className="overflow-hidden py-4">
        <Marquee
          gradient={true}
          gradientWidth={80}
          speed={40}
          pauseOnHover={true}
          className="flex items-center"
        >
          {imagesArray.length > 0
            ? imagesArray.map((imgObj, index) => (
                <div key={index} className="mx-10 flex items-center">
                  <img
                    src={imgObj.url || fallbackImages[index % fallbackImages.length]}
                    alt={imgObj.alt || `Featured ${index + 1}`}
                    className="md:h-16 h-12 w-24 lg:w-48 object-contain transition-transform duration-300 hover:scale-105"
                  />
                </div>
              ))
            : fallbackImages.map((fallbackImg, index) => (
                <div key={index} className="mx-10 flex items-center">
                  <img
                    src={fallbackImg}
                    alt={`Fallback ${index + 1}`}
                    className="md:h-16 h-12 object-contain transition-transform duration-300 hover:scale-105"
                  />
                </div>
              ))}
        </Marquee>
      </div>
    </section>
  );
}

export default FeaturedIn;
